import { Button } from "@similarweb/ui-components";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import {
    RecommendationsEmptyStateImageAndText,
    RecommendationsSidebarEmptyStateBoldTitle,
    RecommendationsSidebarEmptyStateButtonReloadContainer,
    RecommendationsSidebarEmptyStateTitle,
    RecommendationsSidebarEmptyStateWrapper,
} from "pro-features/pages/workspace/common components/RecommendationsSidebar/StyledComponents";
import { RecommendationsEmptyState } from "pro-features/pages/workspace/common components/RecommendationsSidebar/RecommendationsEmptyState";
import type { OpportunityListType } from "../../../types";

type RecommendationsEmptyProps = {
    list: OpportunityListType;
    onRefresh(): void;
};

const RecommendationsEmpty = (props: RecommendationsEmptyProps) => {
    const translate = useTranslation();
    const { list, onRefresh } = props;

    return (
        <RecommendationsSidebarEmptyStateWrapper>
            {list.opportunities.length > 0 ? <RecommendationsSidebarEmptyStateButtonReloadContainer>
                    <Button
                        type="flat"
                        onClick={onRefresh}
                        dataAutomation="recommendations-sidebar-reload"
                    >
                        {translate("workspace.recommendation_sidebar.refresh")}
                    </Button>
                </RecommendationsSidebarEmptyStateButtonReloadContainer> : null}
            <RecommendationsEmptyStateImageAndText>
                {RecommendationsEmptyState}
                <RecommendationsSidebarEmptyStateBoldTitle>
                    {translate("workspace.recommendation_sidebar.empty_state.title")}
                </RecommendationsSidebarEmptyStateBoldTitle>
                <RecommendationsSidebarEmptyStateTitle>
                    {translate("workspace.recommendation_sidebar.empty_state")}
                </RecommendationsSidebarEmptyStateTitle>
            </RecommendationsEmptyStateImageAndText>
        </RecommendationsSidebarEmptyStateWrapper>
    );
};

export default RecommendationsEmpty;
